import SingleSelectBox from "../../components/FormComponents/SingleSelectBox";
import { useState } from "react";
import Input from "../../components/FormComponents/Input";
import Button from "../../components/FormComponents/Button";
import { toastError } from "../../utils/toastUtils";

const CreateTemplate = ({ create }) => {
  const [templateConfig, setTemplateConfig] = useState({
    name: "",
    type: "",
    is_offline: false
  });

  const handleChangeTemplateConfig = (name, value) => {
    setTemplateConfig((prev) => ({ ...prev, [name]: value }));
  };

  const createTemplate = () => {
    if (templateConfig.name.trim().length < 3) {
      toastError("Name must be at least 3 characters");
      return;
    }
    create(templateConfig);
  };

  const masterdataTypeOptions = [
    { id: "learning_text", name: "Learning Text" },
    { id: "custom", name: "Custom" },
    { id: "key_value", name: "Key-Value" },
    { id: "grid", name: "Grid" },
    { id: "color_config", name: "Color-config" }
  ];

  return (
    <div className="builder_form">
      <Input
        type="checkbox"
        label="Offline"
        name="is_offline"
        checked={templateConfig.is_offline}
        onChange={(e) => handleChangeTemplateConfig(e.target.name, e.target.checked)}
        containerClassName="d_flex justify_start"
      />

      <Input
        label="Enter Masterdata Name"
        name="name"
        value={templateConfig.name}
        onChange={(e) => handleChangeTemplateConfig(e.target.name, e.target.value)}
      />

      <SingleSelectBox
        selectedData={templateConfig.type}
        options={masterdataTypeOptions}
        onChange={(obj) => handleChangeTemplateConfig("type", obj.id)}
        placeholder="Select Masterdata Type"
        label="Enter Masterdata Type"
      />

      <Button onClick={createTemplate}>Create</Button>
    </div>
  );
};

export default CreateTemplate;
